module.exports = __webpack_public_path__ + "static/img/t8.113914a0.png";